// Learning categories. icon = lucide-react component name (resolved in UI).
export const CATEGORIES = [
  {
    id: "early-learning",
    icon: "Blocks",
    color: "#FF91B8",
    name: { en: "Early Learning", zh: "启蒙学习" },
    desc: { en: "Alphabet, numbers, colors, shapes, and reading basics.", zh: "字母、数字、颜色、形状与阅读基础。" },
  },
  {
    id: "mathematics",
    icon: "Calculator",
    color: "#147DEB",
    name: { en: "Mathematics", zh: "数学" },
    desc: { en: "Counting, addition, subtraction, and number patterns.", zh: "数数、加法、减法与数字规律。" },
  },
  {
    id: "science",
    icon: "Leaf",
    color: "#45C878",
    name: { en: "Science & Nature", zh: "科学与自然" },
    desc: { en: "Animals, plants, weather, space, and big ideas.", zh: "动物、植物、天气、太空与基础科学概念。" },
  },
  {
    id: "languages",
    icon: "Languages",
    color: "#FFC928",
    name: { en: "Languages", zh: "语言" },
    desc: { en: "English vocabulary, everyday expressions, and reading.", zh: "英语词汇、日常表达与阅读理解。" },
  },
  {
    id: "digital",
    icon: "Laptop",
    color: "#147DEB",
    name: { en: "Digital Literacy", zh: "数字素养" },
    desc: { en: "Online safety, computers, AI, and digital citizenship.", zh: "网络安全、计算机、人工智能与数字公民。" },
  },
  {
    id: "financial",
    icon: "PiggyBank",
    color: "#45C878",
    name: { en: "Financial Literacy", zh: "财商启蒙" },
    desc: { en: "Saving, needs vs wants, budgeting, and money basics.", zh: "储蓄、需要与想要、预算与金钱基础。" },
  },
  {
    id: "kindness",
    icon: "Heart",
    color: "#FF91B8",
    name: { en: "Kindness & Giving", zh: "善良与奉献" },
    desc: { en: "Empathy, sharing, and community support.", zh: "同理心、分享与社区互助。" },
  },
];

export const DIFFICULTIES = [
  { id: "easy", key: "common.difficultyEasy" },
  { id: "medium", key: "common.difficultyMedium" },
  { id: "hard", key: "common.difficultyHard" },
];

export const AGE_BANDS = ["3-5", "6-8", "9-12"];

export function getCategory(id) {
  return CATEGORIES.find((c) => c.id === id);
}
